export default __webpack_public_path__ + "static/media/icon-rightarrow-greenlight.6933a57f.svg";